import { GDTApiErrors } from '@/types';
import {
  ResponseMiCuenta,
  ResponseProductosDisponibles,
  ResponseDetallePaquetePin,
} from '@/types/myAccount';
import { ResponseAssociatePins } from '@/types/pins';
import { TEXTS, URLs, axiosErrorHandler } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

export const getInitMyaccount = axiosErrorHandler(async () => {
  const url = URLs.MI_CUENTA.INIT;
  const response = await axiosGdt.get<ResponseMiCuenta | GDTApiErrors>(url);
  return response.data;
}, TEXTS.pins.errorGetInit);

export const getProductsMyaccount = axiosErrorHandler(async () => {
  const url = URLs.MI_CUENTA.PRODUCTOS_DISPONIBLES;
  const response = await axiosGdt.get<
    ResponseProductosDisponibles | GDTApiErrors
  >(url);
  return response.data;
}, TEXTS.pins.errorGetInit);

/**
 * Initial data for "My Account" section
 */
export const getInitMyAccountExtra = axiosErrorHandler(async () => {
  const promise1 = getInitMyaccount();
  const promise2 = getProductsMyaccount();
  const [initData, products] = await Promise.all([promise1, promise2]);
  return {
    products,
    initData,
  };
}, TEXTS.pins.errorGetInit);

export const postAssociatePin = axiosErrorHandler(async (pin: string) => {
  const url = `${URLs.MI_CUENTA.ASOCIAR_PIN}&pin=${encodeURIComponent(pin)}`;
  const response = await axiosGdt.post<ResponseAssociatePins | GDTApiErrors>(
    url
  );

  return response.data;
}, TEXTS.defaultError);

export const getDetailPinPackage = axiosErrorHandler(async (idMov: number) => {
  const url = `${URLs.MI_CUENTA.DETALLE_PAQUETE}?idMov=${idMov}`;
  const response = await axiosGdt.get<ResponseDetallePaquetePin>(url);

  return response.data;
}, TEXTS.defaultError);
